"use client";
import { jsx as e } from "react/jsx-runtime";
import { SelectItem as d, SelectItemText as c } from "../../atoms/Select/Select.mjs";
import { cn as k } from "../../../utils/utils.mjs";
const o = ({ className: r, children: t, ...a }) => /* @__PURE__ */ e(
  d,
  {
    className: k(
      "dark:bg-neutral-dark-200 dark:hover:bg-neutral-dark-400 dark:text-neutral-dark-1000 dark:data-[state=checked]:bg-neutral-dark-400 dark:focus:bg-neutral-dark-400",
      r
    ),
    ...a,
    children: /* @__PURE__ */ e(c, { children: t })
  }
);
export {
  o as SelectInputItem
};
